export default __webpack_public_path__ + "ea81cceab46d74cfbfaf003304b65282.png";